/**
 * MY — Appointment of Secretary (M32117) Register Detail 매핑.
 * TASK_DATA.formData 는 PreSetAppointmentOfSecretaryPanel 의 officerData 형태
 * (secretaries[] + 회사 필드) 를 그대로 사용한다.
 */
import { registerRegisterDetail } from '@/features/startTask/preset_task/shared/preset/register/registerDetailRegistry';
import { lookupB15Label } from '@/features/startTask/preset_task/shared/preset/lookups/b15NationalityCache';
import { formatDocDate } from '@/shared/composables/dateUtils';

// Nationality 라벨 resolver — secretaries.0.nationality 가 비어있고 nationalityCd 만 있는 기존 task 도
//   B15 캐시 동기 lookup 으로 코드명 표시. 캐시 미스 시 입력 그대로 (코드).
function formatNationality(raw: any): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  // 이미 라벨이면 (B15 형식 아닐 때) 그대로.
  if (!/^B15\d+/i.test(s)) return s;
  return lookupB15Label(s);
}

/**
 * 모든 날짜 필드를 세션 dateFormat 으로 통일 (예: "1982-11-11" → "11/11/1982" 등).
 *   formatDocDate 가 sessionStore.user.user.dateFormat 사용. 비어있으면 'DD MMM YYYY' 폴백.
 *   raw 가 비어있거나 파싱 실패 시 원본 그대로.
 */
function formatSessionDate(raw: any): string {
  const s = String(raw || '').trim();
  if (!s) return '';
  try {
    return formatDocDate(s) || s;
  } catch {
    return s;
  }
}

registerRegisterDetail('M32117', {
  title: 'New Secretary Details',
  repeatArrayPath: 'secretaries',
  fields: [
    { label: 'Full Name', key: ['secretaries.0.fullName', 'new_secretary_1_full_name'] },
    { label: 'Qualification', key: ['secretaries.0.qualificationType', 'new_secretary_1_license_or_membership_number'] },
    { label: 'Qualification / Membership No.', key: ['secretaries.0.qualificationNumber', 'new_secretary_1_maicsa_number', 'new_secretary_1_mia_number', 'new_secretary_1_ls_number'] },
    { label: 'SSM Practising Certificate No.', key: ['secretaries.0.ssmPractisingCertificateNumber', 'new_secretary_1_ssm_practising_certificate_number'] },
    { label: 'NRIC / Passport No', key: ['secretaries.0.nric', 'new_secretary_1_nric_or_passport_number'] },
    {
      label: 'Date of Birth',
      key: ['secretaries.0.dob', 'new_secretary_1_date_of_birth'],
      format: formatSessionDate,
    },
    { label: 'Gender', key: ['secretaries.0.gender', 'new_secretary_1_gender'] },
    { label: 'Race', key: ['secretaries.0.race', 'new_secretary_1_race'] },
    // 라벨 우선 (`secretaries.0.nationality` = B15 코드명, 예: "MALAYSIA"), 없으면 코드(B15xxx) 폴백.
    //   기존 task 는 nationality 라벨 미저장 → format 으로 B15 캐시에서 동기 lookup.
    {
      label: 'Nationality',
      key: ['secretaries.0.nationality', 'new_secretary_1_nationality', 'secretaries.0.nationalityCd'],
      format: formatNationality,
    },
    { label: 'Business / Occupation', key: ['secretaries.0.occupation', 'new_secretary_1_business_occupation'] },
    {
      label: 'Date of Appointment',
      key: ['secretaries.0.appointmentDate', 'new_secretary_1_date_of_appointment', 'appointedDate'],
      format: formatSessionDate,
    },
    { label: 'Residential Address', key: ['secretaries.0.residentialAddress', 'new_secretary_1_residential_address'] },
    { label: 'Firm', key: ['secretaries.0.firm', 'new_secretary_1_firm'] },
    { label: 'Tel', key: ['secretaries.0.tel', 'new_secretary_1_tel'] },
    { label: 'Email', key: ['secretaries.0.email', 'new_secretary_1_email'] },
  ],
});
